// import React from "react";
// import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
// // import OwnerFooter from "../components/OwnerFooter";

// const AddProperty = () => {

//   const Input = ({ label }) => (
//     <div style={{ marginBottom: 16 }}>
//       <label>{label}</label>
//       <input style={{
//         width: "100%",
//         padding: 12,
//         borderRadius: 10,
//         border: "1px solid #ddd",
//         marginTop: 5
//       }} />
//     </div>
//   );

//   return (
//     <>
//     <PropertyOwnerNavbar /> 

//     <div style={{ padding: 20, paddingBottom: 120, marginTop:'5%'}}>

//       <h2>Add New Property</h2>

//       <Input label="Property Title" />
//       <Input label="Location" />
//       <Input label="Price" />
//       <Input label="Area" />

//       <div style={{ marginBottom: 16 }}>
//         <label>Description</label>
//         <textarea rows={4} style={{
//           width: "100%",
//           padding: 12,
//           borderRadius: 10,
//           border: "1px solid #ddd",
//           marginTop: 5
//         }} />
//       </div>

//       <button style={{
//         width: "100%",
//         background: "#8a2d5d",
//         color: "#fff",
//         padding: 14,
//         borderRadius: 12,
//         border: "none",
//         fontSize: 16,
//         cursor: "pointer"
//       }}>
//         Add Property
//       </button>

//       {/* <OwnerFooter /> */}
//     </div>

//     </>
//   );
// };

// export default AddProperty;


// import React from "react";
// import PropertyOwnerNavbar from "./PropertyOwnerNavbar";

// const AddProperty = () => {

//   const Input = ({ label, placeholder }) => (
//     <div style={{ display: "flex", flexDirection: "column" }}>
//       <label style={{
//         fontSize: 14,
//         color: "#555",
//         marginBottom: 6,
//         fontWeight: 500
//       }}>
//         {label}
//       </label>

//       <input
//         placeholder={placeholder}
//         style={{
//           padding: 14,
//           borderRadius: 12,
//           border: "1px solid #ddd",
//           outline: "none",
//           fontSize: 14,
//           background: "#fafafa"
//         }}
//       />
//     </div>
//   );

//   return (
//     <>
//       <PropertyOwnerNavbar />

//       <div style={{
//         padding: 20,
//         paddingBottom: 120,
//         marginTop: "5%",
//         maxWidth: 1000,
//         marginInline: "auto"
//       }}>

//         {/* Header */}
//         <h2 style={{
//           marginBottom: 20,
//           fontWeight: 600
//         }}>
//           Add New Property
//         </h2>

//         {/* Card container */}
//         <div style={{
//           background: "#fff",
//           borderRadius: 18,
//           padding: 24,
//           boxShadow: "0 10px 30px rgba(0,0,0,0.06)"
//         }}>

//           {/* Form grid */}
//           <div style={{
//             display: "grid",
//             gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
//             gap: 18
//           }}>

//             <Input label="Zone" placeholder="Select Zone" />
//             <Input label="Property Title" placeholder="Green Valley Plot" />
//             <Input label="Location" placeholder="City / Area" />
//             <Input label="Price" placeholder="₹10,00,000" />
//             <Input label="Area (sq ft)" placeholder="1200 sq ft" />
//             <Input label="Category" placeholder="Residential" />

//           </div>

//           {/* Description */}
//           <div style={{ marginTop: 18 }}>
//             <label style={{
//               fontSize: 14,
//               color: "#555",
//               fontWeight: 500
//             }}>
//               Description
//             </label>

//             <textarea
//               rows={4}
//               placeholder="Describe your property..."
//               style={{
//                 width: "100%",
//                 padding: 14,
//                 borderRadius: 12,
//                 border: "1px solid #ddd",
//                 marginTop: 6,
//                 resize: "none",
//                 background: "#fafafa"
//               }}
//             />
//           </div>

//           {/* Image Upload */}
//           <div style={{ marginTop: 22 }}>
//             <label style={{ fontWeight: 500 }}>
//               Property Images
//             </label>

//             <div style={{
//               border: "2px dashed #ddd",
//               borderRadius: 14,
//               padding: 30,
//               textAlign: "center",
//               marginTop: 8,
//               background: "#fafafa",
//               cursor: "pointer"
//             }}>
//               <div style={{ fontSize: 32 }}>📤</div>
//               <p style={{ margin: 6 }}>
//                 Click to upload images
//               </p>
//               <small>PNG, JPG up to 10MB</small>
//             </div>
//           </div>

//           {/* Document Upload */}
//           <div style={{ marginTop: 20 }}>
//             <label style={{ fontWeight: 500 }}>
//               Property Documents
//             </label>

//             <div style={{
//               border: "2px dashed #ddd",
//               borderRadius: 14,
//               padding: 30,
//               textAlign: "center",
//               marginTop: 8,
//               background: "#fafafa",
//               cursor: "pointer"
//             }}>
//               <div style={{ fontSize: 32 }}>📄</div>
//               <p style={{ margin: 6 }}>
//                 Upload property documents
//               </p>
//             </div>
//           </div>

//           {/* Submit */}
//           <button style={{
//             width: "100%",
//             background: "linear-gradient(135deg,#8a2d5d,#b94d84)",
//             color: "#fff",
//             padding: 16,
//             borderRadius: 14,
//             border: "none",
//             fontSize: 16,
//             cursor: "pointer",
//             marginTop: 24,
//             fontWeight: 600,
//             boxShadow: "0 8px 20px rgba(138,45,93,0.3)"
//           }}>
//             Add Property
//           </button>

//         </div>

//       </div>
//     </>
//   );
// };

// export default AddProperty;



import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { City } from "country-state-city";
import PropertyOwnerNavbar from "./PropertyOwnerNavbar";
import { GoogleMap, Marker, Polygon, useJsApiLoader } from "@react-google-maps/api";
import Autocomplete from "react-google-autocomplete";

const API = "https://api.propertygalleria.in/master/api";
const APII = "http://localhost:4001"

const GOOGLE_MAPS_APIKEY = "AIzaSyAmGcPTfePx1WqX-8bqlPno6-5hU_GE9uA";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const AddProperty = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [zones, setZones] = useState([]);
  const [categories, setCategories] = useState([]);
  const [cities, setCities] = useState([]);

  const [form, setForm] = useState({
    zone_code: "",
    zone_desc: "",
    title: "",
    location: "",
    price: "",
    area: "",
    category: "",
    description: ""
  });

  const [images, setImages] = useState([]);
  const [docs, setDocs] = useState([]);

  /* ================= Fetch Dropdown Data ================= */
  useEffect(() => {
    axios.get(`${API}/api/zones`).then(res => setZones(res.data));
    axios.get(`${API}/get/property_categories`).then(res => setCategories(res.data));

    const indiaCities = City.getCitiesOfCountry("IN")
      .map(c => c.name)
      .sort();
    setCities(indiaCities);
  }, []);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  /* ================= Submit ================= */
  const handleSubmitt = async () => {
    const data = new FormData();

    data.append("user_id", user.id);
    Object.keys(form).forEach(key =>
      data.append(key, form[key])
    );

    images.forEach(img => data.append("profile_photo", img));
    docs.forEach(doc => data.append("property_docs", doc));

    try {
      await axios.post(`${API}/api/owner/properties`, data);
      alert("Property Added Successfully");
      window.location.reload();
    } catch (err) {
      alert("Upload Failed");
    }
  };
  const handleSubmit = async () => {

    const data = new FormData();

    data.append("user_id", user.id);

    Object.keys(form).forEach(key => {
      data.append(key, form[key]);
    });

    // Send map boundary
    if (boundaryPoints.length === 4) {
      data.append("boundary_points", JSON.stringify(boundaryPoints));
      data.append("plot_area", plotArea);
    }

    images.forEach(img => data.append("profile_photo", img));
    docs.forEach(doc => data.append("property_docs", doc));

    try {

      await axios.post(`${API}/api/owner/properties`, data, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      alert("Property Added Successfully");
      window.location.reload();

    } catch (err) {

      console.error(err);
      alert("Upload Failed");

    }
  };
  /* ================= UI ================= */
  const inputStyle = {
    padding: 14,
    borderRadius: 12,
    border: "1px solid #ddd",
    background: "#fafafa",
    width: "100%",
    fontSize: 14
  };

  const [mapCenter, setMapCenter] = useState({ lat: 17.385044, lng: 78.486671 });
  const [boundaryPoints, setBoundaryPoints] = useState([]);
  const [plotArea, setPlotArea] = useState(0);
  const [mapModal, setMapModal] = useState(false);
  const [mapType, setMapType] = useState("hybrid");
  const [location, setLocation] = useState("");
  const [cityCoords, setCityCoords] = useState(null);

  const mapRef = useRef(null);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_APIKEY,
    libraries: ["places"],
  });

  const handleMapClick = (e) => {
    if (boundaryPoints.length < 4) {
      const newPoints = [
        ...boundaryPoints,
        { latitude: e.latLng.lat(), longitude: e.latLng.lng() },
      ];

      setBoundaryPoints(newPoints);

      if (newPoints.length >= 3) {
        calculatePolygonArea(newPoints);
      }
    } else {
      alert("4 points already selected");
    }
  };

  const calculatePolygonArea = (points) => {

    if (points.length < 3) {
      setPlotArea(0);
      return;
    }

    const R = 6378137;
    let area = 0;

    for (let i = 0; i < points.length; i++) {
      const p1 = points[i];
      const p2 = points[(i + 1) % points.length];

      const lat1 = (p1.latitude * Math.PI) / 180;
      const lat2 = (p2.latitude * Math.PI) / 180;
      const lon1 = (p1.longitude * Math.PI) / 180;
      const lon2 = (p2.longitude * Math.PI) / 180;

      area += (lon2 - lon1) * (2 + Math.sin(lat1) + Math.sin(lat2));
    }

    area = (area * R * R) / 2;

    const sqm = Math.abs(area);
    const sqft = sqm * 10.7639;

    setPlotArea(Math.round(sqft));
  };

  const onMarkerDragEnd = (index, e) => {

    const updated = [...boundaryPoints];

    updated[index] = {
      latitude: e.latLng.lat(),
      longitude: e.latLng.lng(),
    };

    setBoundaryPoints(updated);
    calculatePolygonArea(updated);
  };

  const goToCurrentLocation = () => {

    navigator.geolocation.getCurrentPosition((pos) => {

      // const coords = {
      //   latitude: pos.coords.latitude,
      //   longitude: pos.coords.longitude,
      // };

      const coords = {
        lat: pos.coords.latitude,
        lng: pos.coords.longitude,
      };

      mapRef.current.panTo(coords);
    });
  };

  // const openMapAndFocus = () => {

  //   if (!cityCoords) {
  //     alert("Please select location first");
  //     return;
  //   }

  //   setMapModal(true);
  // };
  const openMapAndFocus = () => {

  if (!cityCoords) {
    alert("Please select location first");
    return;
  }

  setMapModal(true);
};

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <PropertyOwnerNavbar />

      <div style={{
        padding: 20,
        paddingBottom: 120,
        maxWidth: 1000,
        margin: "80px auto"
      }}>
        <h2>Add New Property</h2>

        <div style={{
          background: "#fff",
          padding: 24,
          borderRadius: 18,
          boxShadow: "0 10px 30px rgba(0,0,0,0.06)"
        }}>

          {/* Grid */}
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px,1fr))",
            gap: 18
          }}>

            {/* Zone */}
            <select
              name="zone_code"
              style={inputStyle}
              onChange={(e) => {
                const zone = zones.find(z => z.zone_code === e.target.value);
                setForm({
                  ...form,
                  zone_code: zone.zone_code,
                  zone_desc: zone.zone_desc
                });
              }}
            >
              <option>Select Zone</option>
              {zones.map(z => (
                <option key={z.id} value={z.zone_code}>
                  {z.zone_desc}
                </option>
              ))}
            </select>

            <input
              placeholder="Property Title"
              name="title"
              style={inputStyle}
              onChange={handleChange}
            />

            {/* City */}
            {/* <select
              name="location"
              style={inputStyle}
              onChange={handleChange}
            >
              <option>Select City</option>
              {cities.map((c, i) => (
                <option key={i}>{c}</option>
              ))}
            </select> */}

            <input
              placeholder="Price"
              name="price"
              style={inputStyle}
              onChange={handleChange}
            />

            <input
              placeholder="Area (sq ft)"
              name="area"
              style={inputStyle}
              onChange={handleChange}
            />

            {/* Category */}
            <select
              name="category"
              style={inputStyle}
              onChange={handleChange}
            >
              <option>Select Category</option>
              {categories.map(c => (
                <option key={c.id} value={c.category_name}>
                  {c.category_name}
                </option>
              ))}
            </select>

          </div>

          {/* Description */}
          <textarea
            rows={4}
            placeholder="Describe property..."
            name="description"
            style={{
              ...inputStyle,
              marginTop: 18,
              resize: "none"
            }}
            onChange={handleChange}
          />
          <div>

            {/* Location Search */}

            <label>Location (Search City/Area)</label>

          
            <Autocomplete
              apiKey={GOOGLE_MAPS_APIKEY}
           
              onPlaceSelected={(place) => {

                const address = place.formatted_address;

                setLocation(address);

                setForm({
                  ...form,
                  location: address
                });

                if (place.geometry) {

                  const lat = place.geometry.location.lat();
                  const lng = place.geometry.location.lng();

                  setCityCoords({
                    latitude: lat,
                    longitude: lng
                  });

                  // IMPORTANT: set map center once
                  setMapCenter({
                    lat: lat,
                    lng: lng
                  });

                }
              }}
              options={{
                types: ["(regions)"],
                componentRestrictions: { country: "in" },
              }}
              style={{
                width: "100%",
                height: "44px",
                padding: "12px",
                borderRadius: 10,
                border: "1px solid #ddd",
                marginBottom: 15
              }}
            />

         
            <button
              onClick={openMapAndFocus}
              style={{
                marginTop: 10,
                padding: 12,
                width: "100%",
                borderRadius: 10,
                border: "1px solid #ddd",
                background: boundaryPoints.length === 4 ? "#10b981" : "#f9fafb",
                color: boundaryPoints.length === 4 ? "#fff" : "#333",
                cursor: "pointer"
              }}
            >
              {boundaryPoints.length === 4
                ? "Boundary Marked ✅"
                : "Select 4 Corners on Map"}
            </button>
            {mapModal && (

              <div style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0,0,0,0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 999
              }}>

                <div style={{
                  width: "90%",
                  maxWidth: 900,
                  background: "#fff",
                  borderRadius: 12,
                  padding: 20
                }}>

                  <h3>Mark Plot Boundaries</h3>

                  {boundaryPoints.length >= 3 && (
                    <div style={{
                      background: "#f3f4f6",
                      padding: 10,
                      borderRadius: 8,
                      marginBottom: 10,
                      fontWeight: 600
                    }}>
                      Area : {plotArea} sq ft
                    </div>
                  )}

                  <GoogleMap
                    mapContainerStyle={containerStyle}
                     center={mapCenter}
                    zoom={16}
                    onClick={handleMapClick}
                    mapTypeId={mapType}
                    onLoad={(map) => (mapRef.current = map)}
                  >

                    {boundaryPoints.map((point, index) => (
                      <Marker
                        key={index}
                        // position={point}
                        position={{
                          lat: point.latitude,
                          lng: point.longitude
                        }}
                        draggable
                        onDragEnd={(e) => onMarkerDragEnd(index, e)}
                        label={(index + 1).toString()}
                      />
                    ))}

                    {boundaryPoints.length > 2 && (
                      <Polygon
                        // path={boundaryPoints}
                        path={boundaryPoints.map(p => ({
                          lat: p.latitude,
                          lng: p.longitude
                        }))}
                        options={{
                          fillColor: "rgba(66,152,126,0.3)",
                          strokeColor: "#42987e",
                          strokeWeight: 3,
                        }}
                      />
                    )}

                  </GoogleMap>

                  {/* Controls */}

                  <div style={{
                    display: "flex",
                    gap: 10,
                    marginTop: 15,
                    flexWrap: "wrap"
                  }}>

                    <button onClick={() => setMapType("roadmap")}>Standard</button>
                    <button onClick={() => setMapType("hybrid")}>Hybrid</button>
                    <button onClick={() => setMapType("satellite")}>Satellite</button>
                    <button onClick={goToCurrentLocation}>My Location</button>

                  </div>

                  <div style={{
                    display: "flex",
                    gap: 10,
                    marginTop: 15
                  }}>

                    <button
                      style={{
                        flex: 1,
                        padding: 12,
                        background: "#ef4444",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8
                      }}
                      onClick={() => {
                        setBoundaryPoints([]);
                        setPlotArea(0);
                      }}
                    >
                      Clear
                    </button>

                    <button
                      style={{
                        flex: 2,
                        padding: 12,
                        background: "#10b981",
                        color: "#fff",
                        border: "none",
                        borderRadius: 8
                      }}
                      onClick={() => {
                        if (boundaryPoints.length === 4) {
                          setMapModal(false);
                        } else {
                          alert("Select 4 corners");
                        }
                      }}
                    >
                      Confirm Location
                    </button>

                  </div>

                </div>
              </div>
            )}

          </div>
          {/* Image Upload */}
          <div style={{ marginTop: 20 }}>
            <label>Property Images</label>
            <input
              type="file"
              multiple
              onChange={(e) => setImages([...e.target.files])}
            />
          </div>

          {/* Document Upload */}
          <div style={{ marginTop: 15 }}>
            <label>Documents</label>
            <input
              type="file"
              multiple
              onChange={(e) => setDocs([...e.target.files])}
            />
          </div>

          {/* Submit */}
          <button
            onClick={handleSubmit}
            style={{
              marginTop: 25,
              width: "100%",
              padding: 16,
              borderRadius: 14,
              border: "none",
              color: "#fff",
              fontSize: 16,
              background:
                "linear-gradient(135deg,#8a2d5d,#b94d84)",
              cursor: "pointer"
            }}
          >
            Add Property
          </button>

        </div>
      </div>
    </>
  );
};

export default AddProperty;
